<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        ">
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link class="text-decoration-none router-link" to="/AgenteService">หน้าแรก</router-link>
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <router-link class="text-decoration-none router-link" to="/AgentHistory">ประวัติการแก้ไข</router-link>
            </li>
            <li class="breadcrumb-item router-link active">
              {{ this.$store.state.PassHistory.JOB_DESC }}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        " style="background-color: #f2f2f2">
        <div class="icon-back">
          <router-link to="/AgentHistory">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8">
          รายละเอียดการแก้ไขข้อมูล
        </div>
      </div>
      <!-- Mobile -->
      <div class="col col-content">
        <div class="d-none d-lg-flex align-items-center border-bottom">
          <div class="icon-back">
            <router-link to="/AgentHistory">
              <img src="@/assets/images/arrow-blue.svg" class="w-100" />
            </router-link>
          </div>
          <div class="
              title
              blue-1
              fw-normal
              ps-md-3
              pe-lg-3
              font-family
              d-none d-md-block d-lg-block
            ">
            รายละเอียดการแก้ไขข้อมูล
          </div>
        </div>
        <div class="pb-3 pb-lg-1">
          <div class="mt-4 mt-lg-2">
            <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
              เลขที่รับงานบริการ :
            </div>
            <div class="blue-1 fs-6 fw-normal">
              <label style="font-family: monospace;">{{ this.$store.state.PassHistory.REQUEST_NO }}</label>
            </div>
          </div>
        </div>
        <div class="pb-3 pb-lg-1">
          <div class="mt-lg-1">
            <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
              ช่องทางที่บริการ :
            </div>
            <div v-if="this.$store.state.PassHistory.FSYSTEM === 'MBA'" class="fs-6 fw-normal blue-1">
              <label style="font-family: monospace;">BLA Easy Click</label>
            </div>
            <div v-if="this.AgentRenewLicenseHistory.IsAgentRenewLicense" class="fs-6 fw-normal blue-1">
              <label style="font-family: monospace;">Bangkok Life Training</label>
            </div>
            <div v-else class="fs-6 fw-normal blue-1">
              <label style="font-family: monospace;">BLA Smart Agent</label>
            </div>
          </div>
        </div>
        <div class="pb-3 pb-lg-1">
          <div class="mt-2 mt-lg-2">
            <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
              วันที่ทำรายการ :
            </div>
            <div v-if="this.AgentRenewLicenseHistory.IsAgentRenewLicense" class="blue-1"
              style="font-family: monospace;">
              {{ this.AgentRenewLicenseHistory.FSYSTEM_DT_TEXT }}
            </div>
            <div v-else class="blue-1" style="font-family: monospace;">
              {{ this.$store.state.PassHistory.FSYSTEM_DT_TEXT }}
            </div>
          </div>
        </div>
        <div class="pb-3 pb-lg-1">
          <div class="mt-2 mt-lg-2">
            <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
              งานบริการ :
            </div>
            <div class="blue-1 fs-5 fw-normal font-family">
              {{ this.$store.state.PassHistory.JOB_DESC }}

              <label v-if="this.$store.state.PassHistory.JOB === 'J14'">
                  : {{ this.$store.state.PassHistory.REMARKS }}
              </label>
            </div>

            <div v-if="this.$store.state.PassHistory.SUBJOB === 'E02'">
              <label class="blue-1 fs-6" style="font-family: monospace;">
                {{ this.NAME_ENG.EPRENAME }}&nbsp;
                {{ this.NAME_ENG.ENAME }}&nbsp;
                {{ this.NAME_ENG.ESURNAME }}
              </label>
            </div>

            <div v-else-if="this.$store.state.PassHistory.SUBJOB === 'E03'">
              <div>
                <label class="gray-3 fs-5 fw-normal font-family">เบอร์มือถือเดิม : </label>
                <label class="blue-1 fs-5 fw-normal font-family">{{ this.O_MOBILE_PHONE }}</label>
              </div>
              <div>
                <label class="gray-3 fs-5 fw-normal font-family">เบอร์มือถือใหม่ : </label>
                <label class="blue-1 fs-5 fw-normal font-family">{{ this.MOBILE_PHONE }}</label>
              </div>

            </div>

            <div v-else-if="this.$store.state.PassHistory.SUBJOB === 'E04'">
              <div>
                <label class="gray-3 fs-5 fw-normal font-family">อีเมลเดิม : </label>
                <label class="blue-1 fs-5 fw-normal font-family">{{ this.O_EMAIL }}</label>
              </div>
              <div>
                <label class="gray-3 fs-5 fw-normal font-family">อีเมลใหม่ : </label>
                <label class="blue-1 fs-5 fw-normal font-family">{{ this.EMAIL }}</label>
              </div>
            </div>

            <div v-else-if="this.$store.state.PassHistory.SUBJOB === 'E05'">
              <div v-for="(address, index) in this.ADDRESS" :key="index">
                <div v-if="address.Type === 'H'">
                  <div class="font-family">
                    <label class="blue-1 fs-5 fw-normal">ที่อยู่ติดต่อ : </label> <br>
                    <label class="gray-3 fs-5 fw-normal">{{ address.Detail }}</label> <br>
                    <label class="gray-3 fs-5 fw-normal">{{ address.Phone }}</label>
                  </div>
                </div>
                <div v-else>
                  <div class="font-family">
                    <label class="blue-1 fs-5 fw-normal">ที่อยู่ตามทะเบียนบ้าน : </label> <br>
                    <label class="gray-3 fs-5 fw-normal">{{ address.Detail }} </label> <br>
                    <label class="gray-3 fs-5 fw-normal">{{ address.Phone }}</label>
                  </div>
                </div>
              </div>
            </div>

            <div v-else-if="this.$store.state.PassHistory.SUBJOB === 'E06'">
              <div class="ps-2">
                <div class="gray-3 fs-5 font-family">เลขที่บัญชี :</div>
                <div class="blue-1" style="font-family: inherit; font-size: 15px;">{{ this.ACC_BANK.ACC_NO }}</div>
                <div class="gray-3 fs-5 font-family">ธนาคาร กรุงเทพ สาขา : </div>
                <div class="blue-1 fs-5 font-family">{{ this.ACC_BANK.ACC_BRANCH }}</div>
              </div>
            </div>

            <div v-else-if="this.$store.state.PassHistory.JOB === 'J02'">
              <div class="ps-2">
                <div v-for="(item, index) in OFFICE_CHG.OFFICE_CHG" :key="index">
                  <label class="gray-3 fs-5 font-family">สาขาปัจจุบัน :</label>&nbsp;
                  <label class="blue-1 fs-5 font-family">{{ item.DESCRIPTION }}</label>
                </div>
                <div>
                  <lable class="gray-3 fs-5 font-family">สาขาใหม่ :</lable>&nbsp;
                  <lable class="blue-1 fs-5 font-family">{{ OFFICE_CHG.OFFICE_NEW }}</lable>
                </div>
                <div class="gray-3 fs-5 font-family">วัตถุประสงค์ของการขอย้าย</div>
                <div class="blue-1 fs-5 font-family ps-2 text-break">{{ OFFICE_CHG.REASON_DTL }}</div>
              </div>
            </div>

            <div v-else-if="this.$store.state.PassHistory.JOB === 'J03'">
              <div class="ps-2">
                <div class="gray-3 fs-5 font-family">ตัวแทนที่ต้องการย้ายสาขา</div>
                <div v-for="(item, index) in OFFICE_CHG.OFFICE_CHG" :key="index" class="blue-1 fs-5 font-family ps-2">
                  รหัส <label style="font-family: monospace; font-size: 13px;">{{ item.AGENTCODE_CHG }}</label> {{
                    item.PRENAME }} {{ item.NAME }} {{ item.SURNAME }} <br />
                  สาขาปัจจุบัน {{ item.DESCRIPTION }}
                </div>
                <div>
                  <lable class="gray-3 fs-5 font-family">สาขาใหม่ : </lable>
                  <lable class="blue-1 fs-5 font-family">{{ OFFICE_CHG.OFFICE_NEW }}</lable>
                </div>
                <div class="gray-3 fs-5 font-family">วัตถุประสงค์ของการขอย้าย</div>
                <div class="blue-1 fs-5 font-family ps-2 text-break">{{ OFFICE_CHG.REASON_DTL }}</div>
              </div>
            </div>

            <div v-else-if="this.$store.state.PassHistory.JOB === 'J04'">
              <div class="ps-2">
                <div class="gray-3 fs-5 font-family">ตัวแทนใต้สังกัดที่ต้องการโอน</div>
                <div v-for="(item, index) in AGT_TRAN.AGT_TRAN" :key="index" class="blue-1 fs-5 font-family ps-2">
                  รหัส <label style="font-family: monospace; font-size: 13px;">{{ item.AGENTCODE_TRAN }}</label> {{
                    item.PRENAME }} {{ item.NAME }} {{ item.SURNAME }}
                </div>
                <div>
                  <lable class="gray-3 fs-5 font-family">สังกัดใหม่ :</lable>&nbsp;
                  <lable class="blue-1 fs-5 font-family">{{ AGT_TRAN.NAME_NEW_LINE }}</lable>
                </div>
              </div>
            </div>

            <div v-else-if="this.$store.state.PassHistory.JOB === 'J05'">
              <div class="ps-2">
                <div class="gray-3 fs-5 font-family">ตัวแทนใต้สังกัดที่ต้องการดำเนินการ</div>
                <div class="blue-1 fs-5 font-family">รหัส &nbsp; <label
                    style="font-family: monospace; font-size: 13px;">{{ PROMOTE.AGENTCODE_PROMOTE }}</label> &nbsp; {{
                      PROMOTE.PRENAME }} {{ PROMOTE.NAME }} {{ PROMOTE.SURNAME }}</div>
                <div>
                  <label class="gray-3 fs-5 font-family">ตำแหน่งปัจจุบัน : </label> &nbsp;
                  <label class="blue-1 fs-5 font-family">{{ PROMOTE.POSTION }}</label>
                </div>
                <div>
                  <label class="gray-3 fs-5 font-family">ตำแหน่งใหม่ : </label> &nbsp;
                  <label class="blue-1 fs-5 font-family">{{ PROMOTE.DESCRIPTION }}</label>
                </div>
                <div class="gray-3 fs-5 font-family">ประสบการณ์ในธุรกิจประกันชีวิต : </div>
                <div class="blue-1 fs-5 font-family ps-2 text-break">{{ PROMOTE.EXP_DETAIL }}</div>
                <div class="gray-3 fs-5 font-family">ข้อมูลเพิ่มเติม : </div>
                <div class="blue-1 fs-5 font-family ps-2 text-break">{{ PROMOTE.AD_INFO_DETAIL }}</div>
              </div>
            </div>

            <div v-else-if="this.$store.state.PassHistory.JOB === 'J06'">
              <div class="ps-2">
                <div class="gray-3 fs-5 font-family">ตัวแทนใต้สังกัดที่ต้องการดำเนินการ</div>
                <div class="blue-1 fs-5 font-family ps-2">รหัส &nbsp; <label
                    style="font-family: monospace; font-size: 13px;">{{ POSITION_CHG.AGENTCODE_CHG }}</label> &nbsp; {{
                      POSITION_CHG.PRENAME }} {{ POSITION_CHG.NAME }} {{ POSITION_CHG.SURNAME }}</div>
                <div>
                  <label class="gray-3 fs-5 font-family">ตำแหน่งปัจจุบัน : </label> &nbsp;
                  <label class="blue-1 fs-5 font-family">{{ POSITION_CHG.POSTION }}</label>
                </div>
                <div>
                  <label class="gray-3 fs-5 font-family">ดำเนินการเพื่อ : </label> &nbsp;
                  <label v-if="POSITION_CHG.CHG_TYPE === 'PM'" class="blue-1 fs-5 font-family">เลื่อนตำแหน่ง</label>
                  <label v-else class="blue-1 fs-5 font-family">ลดตำแหน่ง</label>
                </div>
                <div>
                  <label class="gray-3 fs-5 font-family">ตำแหน่งใหม่ : </label> &nbsp;
                  <label class="blue-1 fs-5 font-family">{{ POSITION_CHG.DESCRIPTION }}</label>
                </div>
                <div class="gray-3 fs-5 font-family">ข้อมูลเพิ่มเติม : </div>
                <div class="blue-1 fs-5 font-family ps-2 text-break">{{ POSITION_CHG.AD_INFO_DETAIL }}</div>
              </div>
            </div>

            <div v-else-if="this.$store.state.PassHistory.JOB === 'J07'">
              <div class="ps-2">
                <div class="gray-3 fs-5 font-family">ตัวแทนที่ต้องการโอนผลงานให้</div>
                <div class="blue-1 fs-5 font-family">รหัส&nbsp;<label
                    style="font-family: monospace; font-size: 13px;">{{ PO_TRAN.AGENTCODE_POL_TRAN
                    }}</label>&nbsp;<label>{{ PO_TRAN.PRENAME }} {{ PO_TRAN.NAME }} {{ PO_TRAN.SURNAME }}</label></div>
              </div>
            </div>

            <div v-else-if="this.$store.state.PassHistory.JOB === 'J08'">
              <div class="ps-2">
                <div v-if="CERT.YEAR != null">
                  <div class="gray-3 fs-5 font-family">ระบุปีที่ต้องการ</div>
                  <div v-if="CHECKYEAR" class="blue-1 fs-5 font-family">แสดงข้อมูลปี พ.ศ. ปัจจุบัน</div>
                  <div v-else class="blue-1 fs-5 font-family">แสดงข้อมูลปี พ.ศ. ก่อนหน้า</div>
                </div>
                <div class="gray-3 fs-5 font-family">วัตถุประสงค์การขอหนังสือรับรอง</div>
                <div class="blue-1 fs-5 font-family">{{ this.CERT.REASON_DTL }}</div>
              </div>
            </div>

            <div v-else-if="this.$store.state.PassHistory.JOB === 'J09'">
              <div class="ps-2">
                <div class="gray-3 fs-5 font-family">ประเภทนามบัตร</div>
                <div v-for="(item, index) in CARD_PRINT.CARD_PRINT" :key="index">
                  <div v-if="item.CARD_TYPE == 'AG'">
                    <div class="blue-1 fs-5 font-family ps-2">ตัวแทนประกันชีวิต <label class="fs-6"
                        style="font-family: monospace;">{{ item.AMOUNT }}</label> กล่อง</div>
                  </div>
                  <div v-else>
                    <div class="blue-1 fs-5 font-family ps-2">ผู้แนะนำการลงทุน <label class="fs-6"
                        style="font-family: monospace;">{{ item.AMOUNT }}</label> กล่อง</div>
                  </div>
                </div>

                <div class="gray-3 fs-5 font-family">ข้อมูลเพิ่มเติม</div>
                <div class="blue-1 fs-5 font-family ps-2 text-break">{{ CARD_PRINT.MEMO }}</div>
              </div>
            </div>

            <div v-else-if="this.$store.state.PassHistory.JOB === 'J10'">
              <div class="ps-2">
                <div class="gray-3 fs-5 font-family">วัตถุประสงค์ที่ต้องการขอลาออก</div>
                <div class="blue-1 fs-5 font-family">{{ this.RESIGN.REASON_DTL }}</div>
              </div>
            </div>

            <div v-else-if="this.$store.state.PassHistory.JOB === 'J11'">
              <div>
                <label class="gray-3 fs-5 fw-normal font-family">{{ this.SociaMediaHistory.PLATFORM }} เดิม : </label>
                <label class="blue-1 fs-5 fw-normal font-family">{{ this.SociaMediaHistory.O_USERNAME }}</label>
              </div>
              <div>
                <label class="gray-3 fs-5 fw-normal font-family">{{ this.SociaMediaHistory.PLATFORM }} ใหม่ : </label>
                <label class="blue-1 fs-5 fw-normal font-family">{{ this.SociaMediaHistory.USERNAME }}</label>
              </div>
            </div>

          </div>
        </div>
        <div class="pb-3 pb-lg-1">
          <div class="mt-1 mt-lg-1">
            <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
              สถานะ :
            </div>
            <div class="blue-1 fs-5 font-family">
              <div v-if="
                (this.$store.state.PassHistory.STATUS === '003' && this.$store.state.PassHistory.SUB_STATUS !== 'S31') ||
                this.$store.state.PassHistory.STATUS === '009' && (this.$store.state.PassHistory.SUB_STATUS !== 'S91' || this.$store.state.PassHistory.SUB_STATUS === 'S92')
              ">
                {{ this.$store.state.PassHistory.STATUS_DESC }} <label class="fs-5 pe-1">วันที่</label>
                <label style="font-family: monospace; font-size: 16px;">
                  {{ this.$store.state.PassHistory.STATUS_DT_TEXT }}
                </label>
              </div>
              <div v-else-if="
                (this.$store.state.PassHistory.STATUS === '009' && (this.$store.state.PassHistory.SUB_STATUS === 'S91' || this.$store.state.PassHistory.SUB_STATUS === 'S92'))
              ">
                {{ this.$store.state.PassHistory.STATUS_DESC }} <label
                  v-if="this.$store.state.PassHistory.SUB_STATUS === null && this.$store.state.PassHistory.STATUS_DT_TEXT !== ''"
                  class="fs-5 pe-1">วันที่</label>
                <label v-if="this.$store.state.PassHistory.SUB_STATUS === null"
                  style="font-family: monospace; font-size: 16px;">{{ this.$store.state.PassHistory.STATUS_DT_TEXT
                  }}</label>
              </div>
              <div v-else>
                {{ this.$store.state.PassHistory.STATUS_DESC }} <label
                  v-if="this.$store.state.PassHistory.SUB_STATUS === null && this.$store.state.PassHistory.STATUS_DT_TEXT !== ''"
                  class="fs-5 pe-1">วันที่</label>
                <label v-if="this.$store.state.PassHistory.SUB_STATUS === null"
                  style="font-family: monospace; font-size: 16px;">{{ this.$store.state.PassHistory.STATUS_DT_TEXT
                  }}</label>
              </div>

              <!-- {{ this.$store.state.PassHistory.STATUS_DESC }} <label v-if="this.$store.state.PassHistory.SUB_STATUS === null && this.$store.state.PassHistory.STATUS_DT_TEXT !== ''">วันที่</label> <label v-if="this.$store.state.PassHistory.SUB_STATUS === null" style="font-family: monospace; font-size: 13px;">{{ this.$store.state.PassHistory.STATUS_DT_TEXT }}</label> -->

              <!-- <div v-if="
                (this.$store.state.PassHistory.STATUS === '003' && this.$store.state.PassHistory.SUB_STATUS !== 'S31') ||
                (this.$store.state.PassHistory.STATUS === '009' && (this.$store.state.PassHistory.SUB_STATUS !== 'S91' || this.$store.state.PassHistory.SUB_STATUS !== 'S92'))
              ">
                {{ this.$store.state.PassHistory.STATUS_DESC }} <label>วันที่</label> <label style="font-family: monospace; font-size: 13px;">{{ this.$store.state.PassHistory.STATUS_DT_TEXT }}</label>
              </div>
              
              <div v-else>
                 {{ this.$store.state.PassHistory.STATUS_DESC }} <label v-if="this.$store.state.PassHistory.SUB_STATUS === null && this.$store.state.PassHistory.STATUS_DT_TEXT !== ''">วันที่</label> <label v-if="this.$store.state.PassHistory.SUB_STATUS === null" style="font-family: monospace; font-size: 13px;">{{ this.$store.state.PassHistory.STATUS_DT_TEXT }}</label>
              </div> -->

              <!-- <div v-if="
                (this.$store.state.PassHistory.STATUS === '009' && this.$store.state.PassHistory.SUB_STATUS !== 'S91' || this.$store.state.PassHistory.SUB_STATUS !== 'S92')
              ">
                {{ this.$store.state.PassHistory.STATUS_DESC }} <label>วันที่</label> <label style="font-family: monospace; font-size: 13px;">{{ this.$store.state.PassHistory.STATUS_DT_TEXT }}</label>
              </div>
              <div v-else> -->
              <!-- {{ this.$store.state.PassHistory.STATUS_DESC }} <label v-if="this.$store.state.PassHistory.SUB_STATUS === null && this.$store.state.PassHistory.STATUS_DT_TEXT !== ''">วันที่</label> <label v-if="this.$store.state.PassHistory.SUB_STATUS === null" style="font-family: monospace; font-size: 13px;">{{ this.$store.state.PassHistory.STATUS_DT_TEXT }}</label> -->
              <!-- </div> -->
            </div>
            <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
              สถานะย่อย :
            </div>
            <div class="blue-1  font-family">
              <div v-if="
                (this.$store.state.PassHistory.STATUS === '003' && this.$store.state.PassHistory.SUB_STATUS === 'S31') ||
                (this.$store.state.PassHistory.STATUS === '009' && this.$store.state.PassHistory.SUB_STATUS === 'S91' || this.$store.state.PassHistory.SUB_STATUS === 'S92')
              ">
                <label class="fs-5 pe-1 ">{{ this.$store.state.PassHistory.SUB_STATUS_DESC }} </label>
                <label
                  v-if="this.$store.state.PassHistory.SUB_STATUS !== null && this.$store.state.PassHistory.STATUS_DT_TEXT !== ''"
                  style="font-family: monospace; font-size: 16px;">{{ this.$store.state.PassHistory.STATUS_DT_TEXT
                  }}</label>
              </div>
              <div v-else-if="
                (this.$store.state.PassHistory.STATUS === '003' && this.$store.state.PassHistory.SUB_STATUS !== 'S31') ||
                (this.$store.state.PassHistory.STATUS === '009' && (this.$store.state.PassHistory.SUB_STATUS !== 'S91' || this.$store.state.PassHistory.SUB_STATUS !== 'S92'))
              "></div>
              <div v-else>
                <label class="fs-5 pe-1">
                  {{ this.$store.state.PassHistory.SUB_STATUS_DESC }} </label>
                <label
                  v-if="this.$store.state.PassHistory.SUB_STATUS !== null && this.$store.state.PassHistory.STATUS_DT_TEXT !== ''"
                  class="fs-5 pe-1">วันที่</label>
                <label
                  v-if="this.$store.state.PassHistory.SUB_STATUS !== null && this.$store.state.PassHistory.STATUS_DT_TEXT !== ''"
                  style="font-family: monospace; font-size: 16px;">{{ this.$store.state.PassHistory.STATUS_DT_TEXT
                  }}</label>
              </div>
            </div>

          </div>
        </div>
        <div class="pb-3 pb-lg-1">
          <div class="mt-2 mt-lg-2">
            <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
              ผู้ดำเนินการ
            </div>
            <div class="blue-1 fs-5  font-family">
              {{ this.$store.state.PassHistory.STATUS_ID_TEXT }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
//import Swal from 'sweetalert2/src/sweetalert2.js'

export default {
  name: "HistoryDetail",
  components: {
    Menu,
    LoadingBs5,
  },
  data() {
    return {
      Loading: true,
      NAME_ENG: {
        EPRENAME: '',
        ENAME: '',
        ESURNAME: '',
      },
      EMAIL: '',
      O_EMAIL: '',
      MOBILE_PHONE: '',
      O_MOBILE_PHONE: '',
      ADDRESS: [],
      ACC_BANK: {
        ACC_BRANCH: '',
        ACC_NO: ''
      },
      OFFICE_CHG: {
        OFFICE_CHG: [],
        OFFICE_NEW: '',
        REASON_DTL: ''
      },
      AGT_TRAN: {
        AGT_TRAN: [],
        NAME_NEW_LINE: '',
      },
      PROMOTE: {
        AGENTCODE_PROMOTE: '',
        EXP_DETAIL: '',
        AD_INFO_DETAIL: '',
        PRENAME: '',
        NAME: '',
        SURNAME: '',
        DESCRIPTION: '',
        POSTION: ''
      },
      POSITION_CHG: {
        CHG_TYPE: '',
        AGENTCODE_CHG: '',
        AD_INFO_DETAIL: '',
        PRENAME: '',
        NAME: '',
        SURNAME: '',
        DESCRIPTION: '',
        POSTION: ''
      },
      PO_TRAN: {
        AGENTCODE_POL_TRAN: '',
        PRENAME: '',
        NAME: '',
        SURNAME: '',
      },
      CERT: {
        REASON_DTL: '',
        YEAR: ''
      },
      CHECKYEAR: false,
      CARD_PRINT: {
        CARD_PRINT: [],
        MEMO: ''
      },
      RESIGN: {
        REASON_DTL: '',
      },
      SociaMediaHistory: {
        PLATFORM: '',
        O_USERNAME: '',
        USERNAME: '',
      },
      AgentRenewLicenseHistory: {
        IsAgentRenewLicense: false,
        FSYSTEM_DT_TEXT: null,
      },
    };
  },
  mounted() {
    if (this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }

    console.log('PassHistory=', this.$store.state.PassHistory);

    let AuthorizeToken = localStorage.getItem("AuthorizeToken");
    http.get("AgencyERequest/GetName?", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
      if (response.status == 200) {
        this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;
        this.Loading = false;
      }
    }).catch(() => {
      this.Loading = false;
      localStorage.removeItem("Token");
      localStorage.removeItem("AuthorizeToken");
      window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
    });

    let params = {
      AER_SERVICE_JOB_ID: this.$store.state.PassHistory.AER_SERVICE_JOB_ID,
      JOB: this.$store.state.PassHistory.JOB,
      SUBJOB: this.$store.state.PassHistory.SUBJOB,
      USER_AG_LEVEL: this.$store.state.User_AG_LEVEL
    };
    http.get("AgencyERequest/GetHistoryDetail?", { headers: { Authorization: `Bearer ${AuthorizeToken}` }, params }).then((res) => {
      if (res.status == 200) {
        if (res.data.AgentRenewLicenseHistory !== null) {
          this.AgentRenewLicenseHistory.IsAgentRenewLicense = res.data.AgentRenewLicenseHistory.IsAgentRenewLicense;
          this.AgentRenewLicenseHistory.FSYSTEM_DT_TEXT = res.data.AgentRenewLicenseHistory.FSYSTEM_DT_TEXT
        }

        if (res.data.SociaMediaHistory !== null) {
          switch (res.data.SociaMediaHistory.PLATFORM) {
            case 'L':
              this.SociaMediaHistory.PLATFORM = 'Line ID'
              break;

            case 'F':
              this.SociaMediaHistory.PLATFORM = 'Facebook'
              break;

            case 'I':
              this.SociaMediaHistory.PLATFORM = 'Instagram'
              break;

            case 'T':
              this.SociaMediaHistory.PLATFORM = 'TikTok'
              break;

            case 'X':
              this.SociaMediaHistory.PLATFORM = 'X'
              break;

            default:
              break;
          }
          this.SociaMediaHistory.O_USERNAME = res.data.SociaMediaHistory.O_USERNAME;
          this.SociaMediaHistory.USERNAME = res.data.SociaMediaHistory.USERNAME;
        }

        this.NAME_ENG.EPRENAME = (res.data.NAME_ENG !== null) ? res.data.NAME_ENG.EPRENAME : "";
        this.NAME_ENG.ENAME = (res.data.NAME_ENG !== null) ? res.data.NAME_ENG.ENAME : "";
        this.NAME_ENG.ESURNAME = (res.data.NAME_ENG !== null) ? res.data.NAME_ENG.ESURNAME : "";
        this.EMAIL = (res.data.EMAIL !== null) ? res.data.EMAIL.EMAIL : "";
        this.MOBILE_PHONE = (res.data.MOBILE_PHONE !== null) ? res.data.MOBILE_PHONE.MOBILE_PHONE : "";
        this.O_EMAIL = (res.data.EMAIL !== null) ? res.data.EMAIL.O_EMAIL : "";
        this.O_MOBILE_PHONE = (res.data.MOBILE_PHONE !== null) ? res.data.MOBILE_PHONE.O_MOBILE_PHONE : "";
        if (res.data.ADDRESS !== null && res.data.ADDRESS.length > 0) {
          res.data.ADDRESS.forEach(item => {
            let AddressName = item.ADDRESS_NAME + " " + item.ADDRESS_NUMBER + " " +
              ((item.MOOH !== '') ? "หมู่." + item.MOOH : '') + " " +
              ((item.SOI !== '') ? "ซ." + item.SOI : '') + " " +
              ((item.ROAD !== '') ? "ถ." + item.ROAD : '') + " " +
              "ต." + item.TAMBOL + " " +
              "อ." + item.AMPHUR + " " +
              "จ." + item.PROVINCE + " " + item.ZIP_CODE;

            this.ADDRESS.push({ Detail: AddressName, Type: item.ADDRESS_TYPE, Phone: item.PHONE_NUMBER });
          });
        }
        this.ACC_BANK.ACC_NO = (res.data.ACC_BANK !== null) ? this.FormatAccNo(res.data.ACC_BANK.ACC_NO, "กรุงเทพ") : "";
        this.ACC_BANK.ACC_BRANCH = (res.data.ACC_BANK !== null) ? res.data.ACC_BANK.ACC_BRANCH : "";

        //GETDETAILOFFICE_CHG
        if (res.data.OFFICE_CHG != null) {
          res.data.OFFICE_CHG.forEach(item => {
            this.OFFICE_CHG.OFFICE_CHG.push(item);
            this.OFFICE_CHG.OFFICE_NEW = item.OFFICE_NEW;
            this.OFFICE_CHG.REASON_DTL = item.REASON_DTL;
          });
        }

        //GETDETAILAGT_TRAN
        if (res.data.AGT_TRAN != null) {
          res.data.AGT_TRAN.forEach(item => {
            this.AGT_TRAN.AGT_TRAN.push(item);
            this.AGT_TRAN.NAME_NEW_LINE = item.PRENAME_NEW_UPLINE + " " + item.NAME_NEW_UPLINE + " " + item.SURNAME_NEW_UPLINE;
          });
        }

        //GETDETAILPROMOTE
        if (res.data.PROMOTE != null) {
          this.PROMOTE.AGENTCODE_PROMOTE = res.data.PROMOTE.AGENTCODE_PROMOTE;
          this.PROMOTE.EXP_DETAIL = res.data.PROMOTE.EXP_DETAIL;
          this.PROMOTE.AD_INFO_DETAIL = res.data.PROMOTE.AD_INFO_DETAIL;
          this.PROMOTE.PRENAME = res.data.PROMOTE.PRENAME;
          this.PROMOTE.NAME = res.data.PROMOTE.NAME;
          this.PROMOTE.SURNAME = res.data.PROMOTE.SURNAME;
          this.PROMOTE.DESCRIPTION = res.data.PROMOTE.DESCRIPTION;
          this.PROMOTE.POSTION = res.data.PROMOTE.POSTION;
        }

        //GETDETAILPOSITION_CHG
        if (res.data.POSITION_CHG != null) {
          this.POSITION_CHG.CHG_TYPE = res.data.POSITION_CHG.CHG_TYPE;
          this.POSITION_CHG.AGENTCODE_CHG = res.data.POSITION_CHG.AGENTCODE_CHG;
          this.POSITION_CHG.AD_INFO_DETAIL = res.data.POSITION_CHG.AD_INFO_DETAIL;
          this.POSITION_CHG.PRENAME = res.data.POSITION_CHG.PRENAME;
          this.POSITION_CHG.NAME = res.data.POSITION_CHG.NAME;
          this.POSITION_CHG.SURNAME = res.data.POSITION_CHG.SURNAME;
          this.POSITION_CHG.DESCRIPTION = res.data.POSITION_CHG.DESCRIPTION;
          this.POSITION_CHG.POSTION = res.data.POSITION_CHG.POSTION;
        }

        //GETDETAILPO_TRAN
        if (res.data.PO_TRAN != null) {
          this.PO_TRAN.AGENTCODE_POL_TRAN = res.data.PO_TRAN.AGENTCODE_POL_TRAN;
          this.PO_TRAN.PRENAME = res.data.PO_TRAN.PRENAME;
          this.PO_TRAN.NAME = res.data.PO_TRAN.NAME;
          this.PO_TRAN.SURNAME = res.data.PO_TRAN.SURNAME;
        }

        //GETDETAILCERTEMPLOYMENT
        if (res.data.CERT != null) {
          this.CERT.REASON_DTL = (res.data.CERT.REASON_DTL !== null) ? res.data.CERT.REASON_DTL : "";
          this.CERT.YEAR = res.data.CERT.YEAR;
          let ConvertYear = parseInt(res.data.CERT.YEAR);
          const date = new Date();
          const NOWYEAR = date.getFullYear() + 543;
          (ConvertYear == NOWYEAR) ? this.CHECKYEAR = true : this.CHECKYEAR = false;
        }

        //GETDETAILCARD_PRINT
        if (res.data.CARD_PRINT != null) {
          res.data.CARD_PRINT.forEach(item => {
            this.CARD_PRINT.CARD_PRINT.push(item);
            this.CARD_PRINT.MEMO = item.AD_INFO_DETAIL;
          });
        }

        //GETDETAILRESIGN
        if (res.data.RESIGN != null) {
          this.RESIGN.REASON_DTL = res.data.RESIGN.REASON_DTL;
        }

      }
    });
  },
  methods: {
    FormatAccNo(Num, Bank) {
      switch (Bank) {
        case "กรุงเทพ":
          Num = Num.slice(0, 3) + "-" + Num.slice(3, 4) + "-" + Num.slice(4, 9) + "-" + Num.slice(9, 10);
          break;
        default:
          Num = Num;
          break;
      }
      return Num;
    },
  },
};
</script>

<style></style>